<template>
    <div>
        <footer class="flex-vcontainer">
            <!--div class="flex-vitem">
                <div id="puntuacion" style="display: none;">
                    <div id="cap">
                        <div class="izq">@lang('global.ratetheweb')</div>
                        <div id="aspa" class="der">
                            <div class="cruzado"></div>
                            <div class="cruzadoo"></div>
                        </div>
                        <div class="desflotar"></div>
                        <div id="punto1" class="izq"></div>
                        <div id="punto2" class="izq"></div>
                        <div id="punto3" class="izq"></div>
                        <div id="punto4" class="izq"></div>
                        <div id="punto5" class="izq"></div>
                        <div class="desflotar"></div>
                    </div>
                    <div id="gracias">@lang('global.thankx')</div>
                </div>
            </div-->
            <div class="flex-container flex-vitem">
                <div class="flex-item footerlinks">
                    <a id="opt-cookiespolicys" href="#" @click.prevent="showcookies">Cookies & Terms of Service</a>
                </div>
                <div class="flex-item footerlinks">
                    <a href="https://pacovalverde.com/" target="_blank" rel="noreferrer">pacovalverde.com</a>
                </div>
                <div class="flex-item text-footer">
                    &copy; 2019
                </div>
            </div>
        </footer>
    </div>
</template>

<script>
    export default {
        methods: {
            showcookies() {
                if(this.$parent.visibleOn == 1) {
                    $( "#main" ).hide( "slow" );
                } else if(this.$parent.visibleOn == 2) {
                    $( "#wallpapers" ).hide( "slow" );
                }
                $( "#cookiestext" ).show( "slow" );
                $( "button" ).blur();
                $( "a" ).blur();
                $( "#header" ).css({'background-color': 'rgb(82, 23, 81)'});
                $( ".options" ).css({'color': '#ffffff'});
                $( ".logo" ).css({'color': '#ffffff'});
                this.$parent.visibleOn = 3;
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/links/Footer.vue